import React, { useState, useEffect } from "react";
import Priority from "./Priority";
import Category from "./Category";
import Status from "./Status";
import "react-datetime/css/react-datetime.css";
// import DateRangePicker from "./DateRangePicker";
import DateTime from "react-datetime";
import { useNavigate } from "react-router-dom";
import ReusableDropzone from "../../../newcommon/fileUploader/fileUploader.js";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Progress,
} from "reactstrap";

import { Panel, PanelBody } from "../../../components/panel/panel.jsx";
import FilePreview from "./FilePreview";
import { ToastContainer } from "react-toastify";
import { getTicket, saveTicket } from "../../../services/tickets.js";
import { useParams } from "react-router";
import auth from "../../../services/authservice.js";
import http from "../../../services/httpService";
import Select from "react-select";
import { saveAttachments } from "../../../services/attachments.js";
import { useLocation } from "react-router-dom";
import CustomQRCode from "../../../components/common/CustomQRCode";
import logo from "../../../assets/images/logo.png";
import { getTicketCategories } from "../../../services/ticketcategories.js";
const apiUrl = process.env.REACT_APP_API_URL;

export default function BasicInfo({
  readOnly,
  setReadOnly,
  data,
  loaded,
  onChangeHandler,
  onInputChange,
  onClickHandler,
  selectedFile,
  removeFile,
  id,
  statusOptions,
  priorityOptions,
  toggleEditMode,
  editMode,
}) {
  const navigate = useNavigate();
  const location = useLocation();
  const previousTab = location.state?.comingFrom;
  const [user, setUser] = useState("");

  const [addAttachements, setAddAttachements] = useState(false);
  const [attachments, setAttachments] = useState([]);
  const [state, setState] = useState({
    attachments: [],
  });
  let [categories, setCategories] = useState([]);
  let [users, setUsers] = useState([]);

  let [ticket, setTicket] = useState({
    _id: "",
    user: "",
    ticketNo: "",
    name: "",
    participants: [],
    department: "",
    subDepartment: "",
    category: "",
    review: "",
    documentNo: "",
    reference: " ",
    deadline: new Date(),
    plannedDate: new Date(),
    createdOn: new Date(),
    locations: "",
    narrative: "",
    field: "",
    tags: "",
    subCategory: "",
    note: "",
    status: "active",
  });
  let populateTicket = async () => {
    try {
      let { data } = await getTicket(id);
      setTicket({ ...data });
      setState({ attachments: data.attachments });
      const { data: category } = await getTicketCategories();
      setCategories(
        category.map((category) => {
          return {
            label: category.name,
            value: category.name,
          };
        })
      );
    } catch (ex) {
      console.error(ex);
      if (ex.response && ex.response.status === 404) console.error(ex);
    }
  };

  let populateUsers = async () => {
    const { data: users } = await http.get(apiUrl + "/users");

    setUsers(
      users.map((user) => ({
        _id: user._id,
        label: user.username,
        value: user._id,
        user: user,
      }))
    );
  };
  const getUser = async () => {
    const u = await auth.getProfile();
    setUser(u);
  };

  let handleChange = ({ target: input }) => {
    const data = { ...ticket };
    data[input.name] = input.value;
    setTicket(data);
  };

  let handleMultiChange = (name, options) => {
    const data = { ...ticket };
    data[name] = options;
    setTicket({ ...data });
  };
  let handleDateChange = (date, field) => {
    setTicket({ ...ticket, [field]: date });
  };

  let formatSelectOption = ({ user }) => (
    <div>
      <div style={{ display: "flex", alignItems: "center" }}>
        <div style={{ marginRight: "10px" }}>
          <img width={15} src={user.imageSrc} alt="img here" />
        </div>
        <div>{user.contactName.first + " " + user.contactName.last} </div>
      </div>
    </div>
  );
  const handleFileChange = (event) => {
    const files = Array.from(event.target.files);
    setAttachments(files);
  };
  let handleSubmit = async (e) => {
    e.preventDefault();
    try {
      let data = { ...ticket };
      //delete data.user

      data.user = ticket.user?._id;
      data.participants = data?.participants.map(
        (participant) => participant._id
      );
      delete data.__v;
      delete data.attachments;
      const resp = await saveTicket(data);
      setReadOnly(true);

      // navigate("/ticket/tickets");
    } catch (err) {
      console.log(err);
    }
  };
  const saveAttachment = async (e) => {
    e.preventDefault();

    try {
      const resp = await saveAttachments(
        attachments,
        "ticket",
        ticket._id,
        (progress) => {
          console.log("progressTime", progress);
        }
      );

      navigate("/ticket/tickets");
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    populateUsers();
    populateTicket();
    getUser();
  }, []);
  return (
    <div>
      <form className="form-horizontal form-bordered">
        <div className="row">
          <div className="col-8">
            <Panel>
              <PanelBody>
                <h3 className="m-t-10">Basic information</h3>
                <div className="form-group row m-b-15">
                  <label className="col-sm-3 col-form-label">Owner</label>
                  <div
                    className="col-sm-9"
                    style={{ display: "flex", gap: 10, alignItems: "center" }}
                  >
                    <img
                      src={ticket?.user?.imageSrc}
                      width={25}
                      style={{}}
                      alt=""
                    />

                    <div>{ticket?.user?.username}</div>

                    {/* <input
                      className="form-control d-inline"
                      style={{ "padding-left": "35px" }}
                      type="text"
                      placeholder="Select owner"
                      name="username"
                      readOnly={readOnly}
                      value={ticket?.user?.username}
                    /> */}
                  </div>
                </div>
                <div className="form-group row m-b-15">
                  <label className="col-sm-3 col-form-label">Name</label>
                  <div className="col-sm-9">
                    <input
                      className="form-control"
                      name="name"
                      type="text"
                      readOnly={readOnly}
                      value={ticket.name || ""}
                      onChange={handleChange}
                    />
                  </div>
                </div>
                <div className="form-group row m-b-15">
                  <label className="col-sm-3 col-form-label">
                    Participants
                  </label>
                  <div className="col-sm-9">
                    <Select
                      isMulti
                      isDisabled={readOnly}
                      name="participants"
                      options={users}
                      formatOptionLabel={formatSelectOption}
                      placeholder={"Select Participants..."}
                      value={users?.filter((opt) => {
                        let participantsIDs = ticket.participants?.map(
                          (el) => el._id
                        );
                        return participantsIDs?.includes(opt.value);
                      })}
                      onChange={(e) => handleMultiChange("participants", e)}
                    />
                  </div>
                </div>

                <div className="form-group row m-b-15">
                  <label className="col-sm-3 col-form-label">Status</label>
                  <div className="col-sm-9">
                    <Status
                      isDisabled={readOnly}
                      readOnly={readOnly}
                      value={{ label: ticket.status, value: ticket.status }}
                      name="status"
                      options={statusOptions}
                      onChange={(e) =>
                        setTicket({ ...ticket, status: e.value })
                      }
                    />
                  </div>
                </div>
                <div className="form-group row m-b-15">
                  <label className="col-sm-3 col-form-label">Priority</label>
                  <div className="col-sm-9">
                    <Priority
                      readOnly={readOnly}
                      value={ticket.priority} // Pass the current value from parent state
                      name="priority"
                      options={priorityOptions}
                      onChange={(e) =>
                        setTicket({ ...ticket, priority: e.value })
                      }
                    />
                  </div>
                </div>
                <div className="form-group row m-b-15">
                  <label className="col-sm-3 col-form-label">Category</label>
                  <div className="col-sm-9">
                    <Select
                      isDisabled={readOnly}
                      id="category"
                      value={categories?.filter(
                        (opt) => ticket.category === opt.label
                      )}
                      options={categories}
                      onChange={(e) =>
                        setTicket({ ...ticket, category: e.label })
                      }
                    />
                  </div>
                </div>
                <div className="form-group row m-b-15">
                  <label className="col-sm-3 col-form-label">
                    Sub-Category
                  </label>
                  <div className="col-sm-9">
                    <input
                      className="form-control"
                      name="subCategory"
                      type="text"
                      readOnly={readOnly}
                      placeholder="Sub-Category"
                      onChange={(e) => handleChange(e)}
                      value={ticket.subCategory}
                    />
                  </div>
                </div>

                <div className="form-group row m-b-15">
                  <label className="col-sm-3 col-form-label">Department</label>
                  <div className="col-sm-9">
                    <input
                      className="form-control"
                      type="text"
                      readOnly={readOnly}
                      name="department"
                      value={ticket.department}
                      input
                      placeholder="Read only input here"
                      onChange={(e) => handleChange(e)}
                    />
                  </div>
                </div>
                <div className="form-group row m-b-15">
                  <label className="col-sm-3 col-form-label">
                    {" "}
                    Sub-department
                  </label>
                  <div className="col-sm-9">
                    <input
                      className="form-control"
                      name="subDepartment"
                      type="text"
                      readOnly={readOnly}
                      placeholder="Sub-Department"
                      onChange={(e) => handleChange(e)}
                      value={ticket.subDepartment}
                    />
                  </div>
                </div>

                <div className="form-group row m-b-15">
                  <label className="col-sm-3 col-form-label">Field</label>
                  <div className="col-sm-9">
                    <input
                      className="form-control"
                      name="field"
                      type="text"
                      readOnly={readOnly}
                      placeholder="Field"
                      onChange={(e) => handleChange(e)}
                      value={ticket.field}
                    />
                  </div>
                </div>
                <div className="form-group row m-b-15">
                  <label className="col-sm-3 col-form-label">Tags</label>
                  <div className="col-sm-9">
                    <input
                      className="form-control"
                      name="tags"
                      type="text"
                      readOnly={readOnly}
                      placeholder="Tags"
                      onChange={(e) => handleChange(e)}
                      value={ticket.tags}
                    />
                  </div>
                </div>
                <div className="form-group row m-b-15">
                  <label className="col-sm-3 col-form-label">Document No</label>
                  <div className="col-sm-9">
                    <input
                      className="form-control"
                      type="text"
                      name="documentNo"
                      placeholder="Document No"
                      readOnly={readOnly}
                      onChange={(e) => handleChange(e)}
                      value={ticket.documentNo}
                    />
                  </div>
                </div>
                <div className="form-group row m-b-15">
                  <label className="col-sm-3 col-form-label">Review</label>
                  <div className="col-sm-9">
                    <input
                      className="form-control"
                      type="text"
                      name="review"
                      placeholder="Review"
                      readOnly={readOnly}
                      onChange={(e) => handleChange(e)}
                      value={ticket.review}
                    />
                  </div>
                </div>
                <div className="form-group row m-b-15">
                  <label className="col-sm-3 col-form-label">Locations</label>
                  <div className="col-sm-9">
                    <input
                      className="form-control"
                      type="text"
                      name="locations"
                      placeholder="Locations"
                      readOnly={readOnly}
                      onChange={(e) => handleChange(e)}
                      value={ticket.locations}
                    />
                  </div>
                </div>
                <div className="form-group row m-b-15">
                  <label className="col-sm-3 col-form-label">Reference</label>
                  <div className="col-sm-9">
                    <input
                      className="form-control"
                      type="text"
                      name="reference"
                      placeholder="Reference"
                      readOnly={readOnly}
                      onChange={(e) => handleChange(e)}
                      value={ticket.reference}
                    />
                  </div>
                </div>
                <div className="form-group row m-b-15">
                  <label className="col-sm-3 col-form-label">DeadLine</label>
                  <div className="col-sm-9">
                    <DateTime
                      name="deadline"
                      inputProps={{
                        placeholder: "Datepicker",
                        disabled: readOnly,
                      }}
                      id={"deadline"}
                      value={new Date(ticket.deadline)}
                      closeOnSelect={true}
                      onChange={(date) => handleDateChange(date._d, "deadline")}
                    />
                  </div>
                </div>
              </PanelBody>
            </Panel>
          </div>
          <div className="col-4">
            <Panel>
              <PanelBody>
                <CustomQRCode logo={logo} value={id} />
              </PanelBody>
            </Panel>
          </div>
        </div>
        <div>
          <Panel>
            <div className="form-group row m-b-15">
              <label className="col-sm-3 col-form-label">Note</label>
              <div className="col-sm-9">
                <textarea
                  rows={4}
                  readOnly={readOnly}
                  className="form-control"
                  type="text"
                  placeholder="Note"
                  name="note"
                  value={ticket.note}
                  onChange={(e) => handleChange(e)}
                />
              </div>
            </div>
            <PanelBody>
              <div className="form-group row m-b-15">
                <label className="col-sm-3 col-form-label">Narrative</label>
                <div className="col-sm-9">
                  {readOnly ? (
                    <p>{ticket?.narrative}</p>
                  ) : (
                    <textarea
                      value={ticket?.narrative}
                      rows="7"
                      name="narrative"
                      // cols="5"
                      className="form-control"
                      style={{ width: "inherit" }}
                      onChange={(e) => handleChange(e)}
                    ></textarea>
                  )}
                </div>
                {/* <div className="col-3">
                  <Panel>
                    <PanelBody>
                    </PanelBody>
                  </Panel>
                </div> */}
              </div>
            </PanelBody>
            <p className="text-right ml-2 mt-4">
              <>
                {!readOnly && (
                  <>
                    <button
                      className="btn btn-danger m-r-5"
                      disabled={readOnly}
                      onClick={(e) => {
                        e.preventDefault();
                        setReadOnly();
                      }}
                    >
                      Cancel
                    </button>
                    <button
                      className="btn btn-primary"
                      onClick={(e) => {
                        handleSubmit(e);
                      }}
                      disabled={readOnly}
                    >
                      Submit
                    </button>
                  </>
                )}
              </>
            </p>
          </Panel>
        </div>
        <div>
          {/* <ReusableDropzone
            populate={populateTicket}
            setState={setState}
            state={state}
            id={ticket._id}
            type="ticket"
          /> */}
          <Panel>
            <PanelBody>
              <h1>Attachments:</h1>
              <button className="btn btn-success">Add attachments</button>
              <FilePreview />
            </PanelBody>
          </Panel>
          ;
        </div>
      </form>
    </div>
  );
}
